export const TERMS_OF_USE_LINK = 'https://www.manifestcyber.com/terms-of-service';

export const PRIVACY_POLICY_LINK = 'https://www.manifestcyber.com/privacy-policy';

export const PROFILE_REFRESH_INTERVAL_IN_MILISECONDS = 1000 * 60; // 1 minute
